import React, { useState, useEffect } from "react";
import {
  TableAction,
  DropDownMenu,
  Text,
  UploadLogo,
  Calender,
} from "../../formitems/Index";
import { useQuery, useMutation } from "@apollo/client";
import { Select } from "antd";
import firebase from "../../../Firebase/firebase";
import { LeftOutlined } from "@ant-design/icons";
import {
  getClientId,
  Fleets,
  SimFormQuery,
  insertSims,
  UpdateSims,
} from "../../../Queries/Manager Query/Simulators/Simulators";
import { Dropdown, Button, Switch, Menu } from "antd";
import { storage } from "../../../Firebase/firebase";
import moment from "moment";
import { DownOutlined } from "@ant-design/icons";
import Iframe from "react-iframe";

const Simulators = () => {
  const [search, setsearch] = useState("");
  const [users, setusers] = useState({});
  const [add_sim_form, setadd_sim_form] = useState(false);
  const [Edit_sim_form, setEdit_sim_form] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState("");
  const [image, setImage] = useState("");
  const [dropdown2, setDropdown2] = useState("");
  const [dropdown3, setDropdown3] = useState("");
  const [simregistration, setSimregistration] = useState("");
  const [simlocation, setSimlocation] = useState("");
  const [simtype, setSimtype] = useState("");
  const [date, setDate] = useState("");
  const [toggle, settoggle] = useState(true);
  const [currentFormData, setCurrentFormData] = useState({});
  const datess = new Date();
  const [url, setUrl] = useState("");
  const datessss = moment(datess).format("YYYY/MM/DD");
  const datte = moment(date).format("YYYY/MM/DD");

  useEffect(() => {
    firebase.auth().onAuthStateChanged(async (user) => {
      if (user) {
        const token = await user.getIdToken();
        const idTokenResult = await user.getIdTokenResult();
        setusers({
          user: user,
          token: idTokenResult,
          jwt: token,
        });
      } else console.log("SIGNED OUT");
    });
  }, []);

  const { data: getclient } = useQuery(getClientId, {
    variables: { id: users?.token?.claims?.user_id },
  });
  const { data: fleet } = useQuery(Fleets, {
    variables: { id: getclient?.aatmsv4_users[0]?.client?.clientsid },
  });
  const { data: simdata } = useQuery(SimFormQuery, {
    variables: {
      id: getclient?.aatmsv4_users[0]?.client?.clientsid,
      fleetid: dropdown2[0],
      active: toggle,
      date: datessss,
    },
  });
  const [addsims, { data: sim }] = useMutation(insertSims, {
    refetchQueries: [
      {
        query: SimFormQuery,
        variables: {
          id: getclient?.aatmsv4_users[0]?.client?.clientsid,
          fleetid: dropdown2[0],
          active: true,
          date: datessss,
        },
      },
      {
        query: SimFormQuery,
        variables: {
          id: getclient?.aatmsv4_users[0]?.client?.clientsid,
          fleetid: dropdown2[0],
          active: false,
          date: datessss,
        },
      },
    ],
  });
  const [updatesims, { data: upsim }] = useMutation(UpdateSims, {
    refetchQueries: [
      {
        query: SimFormQuery,
        variables: {
          id: getclient?.aatmsv4_users[0]?.client?.clientsid,
          fleetid: dropdown2[0],
          active: true,
          date: datessss,
        },
      },
      {
        query: SimFormQuery,
        variables: {
          id: getclient?.aatmsv4_users[0]?.client?.clientsid,
          fleetid: dropdown2[0],
          active: false,
          date: datessss,
        },
      },
    ],
  });

  const add_new = () => {
    setadd_sim_form(true);
  };
  const closeForm = () => {
    setadd_sim_form(false);
    setEdit_sim_form(false);
  };
  const EditSim = (data) => {
    setEdit_sim_form(true);
    setCurrentFormData(data);
  };
  const togle = () => {
    toggle ? settoggle(false) : settoggle(true);
  };

  const handChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileType = file["type"];
      const validImageTypes = ["application/pdf"];
      if (validImageTypes.includes(fileType)) {
        setError("");
        setImage(file);
        setUrl("");
      } else {
        setError("Please select an pdf to upload");
      }
    }
  };

  const handleUpdate = () => {
    if (image) {
      const uploadTask = storage
        .ref(
          `${getclient?.aatmsv4_users[0]?.client?.clientname}/SIM/${image.name}`
        )
        .put(image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          setProgress(progress);
        },
        (error) => {
          setError(error);
        },
        () => {
          storage
            .ref(`${getclient?.aatmsv4_users[0]?.client?.clientname}/SIM`)
            .child(image.name)
            .getDownloadURL()
            .then((url) => {
              setUrl(url);
              setProgress(0);
            });
        }
      );
    } else {
      setError("Error please choose an image to upload");
    }
  };
  const handleFormFields = (v, fieldName) => {
    switch (fieldName) {
      case "active":
        setCurrentFormData({ ...currentFormData, active: v });
        break;
      default:
        break;
    }
  };
  const emptyState = () => {
    setImage("");
    setDropdown2("");
    setDropdown3("");
    setSimregistration("");
    setSimlocation("");
    setSimtype("");
    setUrl("");
  };

  const menu = (el) => (
    <Menu>
      <Menu.Item>
        <p
          onClick={() => {
            EditSim(el);
          }}
        >
          Edit
        </p>
      </Menu.Item>
    </Menu>
  );
  const Option = Select.Option;
  return (
    <div className="animate__animated animate__fadeIn">
      <div
        className={
          "simulators-container " +
          (add_sim_form || Edit_sim_form ? "hide-element" : "")
        }
      >
        <div className="category-title">Simulators</div>
        <button className="submit-button" onClick={add_new}>
          Add New Simulator
        </button>
        <div className="table-body-container">
          <div className="table-body-header">All Simulators</div>
          <div className="client-list-divider"></div>
          <div className="table-container">
            <div className="table-header-container">
              <div className="display-record">
                <Select
                  value={dropdown2 ? dropdown2[1] : "Select Fleet"}
                  onChange={(e) => setDropdown2(e)}
                >
                  {fleet?.aatmsv4_fleets?.map((el, i) => (
                    <Option key={i} value={[el.fleetsid, el.aircraft]}>
                      {el.aircraft}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="active-switch">
                <span>Active</span>
                <Switch onClick={togle} defaultChecked />
              </div>
              <div className="search-bar">
                <span>Search</span>
                <input
                  type="text"
                  value={search}
                  onChange={(e) => setsearch(e.target.value)}
                />
              </div>
            </div>
            {dropdown2 !== "" &&
              simdata?.aatmsv4_sims?.map((data, index) => {
                if (
                  data?.simlocation.toLowerCase().includes(search.toLowerCase())
                ) {
                  return (
                    <div className="table-row-container" key={index}>
                      <div className="table-row-top">
                        <div className="items">
                          <div className="title">Aircraft</div>
                          <div className="value">{data?.fleet?.aircraft}</div>
                        </div>
                        <div className="items">
                          <div className="title">Sim-Type</div>
                          <div className="value">{data.simtype}</div>
                        </div>
                        <div className="items">
                          <div className="title">Sim-Location</div>
                          <div className="value">
                            <Dropdown overlay={menu(data)}>
                              <a
                                className="ant-dropdown-link"
                                onClick={(e) => e.preventDefault()}
                                id="uploadQualifications-dropdown"
                              >
                                <div className="value">
                                  {data.simlocation}
                                  <DownOutlined />
                                </div>
                              </a>
                            </Dropdown>
                          </div>
                        </div>
                        <div className="items">
                          <div className="title">Sim-Registration</div>
                          <div className="value">{data.simreg}</div>
                        </div>
                        <div className="items">
                          <div className="title">Validity</div>
                          <div className="value">{data.validity}</div>
                        </div>
                        <div className="items">
                          <div className="title">Validity</div>
                          <div className="value">{data.validity}</div>
                        </div>

                        {/* <div className="items">
                          <div className="title">Edit</div>
                          <div className="value">
                            <Button
                              type="primary"
                              onClick={() => {
                                EditSim(data);
                              }}
                            >
                              Edit
                            </Button>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  );
                }
              })}
          </div>
        </div>
        {/* <div className="print-email-container">
          <button className="submit-button" style={{ marginTop: "unset" }}>
            <i className="fa fa-download" />
            Download
          </button>
          <button className="print-button">
            <i className="fa fa-print" />
            Print
          </button>
          <button className="email-button">
            <i className="fa fa-envelope" />
            Email
          </button>
        </div> */}
      </div>
      {/* add new form */}
      <div className={add_sim_form ? "" : "hide-element"}>
        <div className="qualificationPage">
          <div className="addQualification__form qualificationPage__left">
            <div className="addQualification__form--title">
              <span className="client-back" onClick={() => closeForm()}>
                {<LeftOutlined />} Simulators
              </span>
              Add New Simulators
            </div>
            <Text
              title="Client"
              disabled={true}
              value={getclient?.aatmsv4_users[0]?.client?.clientname}
            />
            {dropdown3 === "" ? (
              <div>
                <p>Fleets</p>
                <Select
                  value={dropdown3 ? dropdown3[1] : "Select Fleet"}
                  onChange={(e) => setDropdown3(e)}
                >
                  {fleet?.aatmsv4_fleets?.map((el, i) => (
                    <Option key={i} value={[el.fleetsid, el.aircraft]}>
                      {el.aircraft}
                    </Option>
                  ))}
                </Select>
              </div>
            ) : (
              <Text title="Fleet" disabled={true} value={dropdown3[1]} />
            )}
            <Text
              title="Sim-Registration"
              value={simregistration}
              onChange={(e) => setSimregistration(e.target.value)}
            />
            <Text
              title="Sim-Type"
              value={simtype}
              onChange={(e) => setSimtype(e.target.value)}
            />
            <Text
              title="Sim-Location"
              value={simlocation}
              onChange={(e) => setSimlocation(e.target.value)}
            />
            <Calender title="Approval Validity" onChange={setDate} />
            <Text title="Active" disabled={true} value="Yes" />
            
            <div>
              <input
                type="file"
                style={{ backgroundColor: "beige", borderRadius: "25px" }}
                onChange={handChange}
              />
              {!url ? (
                <button className="cancel-button" onClick={handleUpdate}>
                  Save
                </button>
              ) : null}
            </div>
            {url !== "" ? (
              <div>
                <button
                  className="submit-button"
                  onClick={() => {
                    addsims({
                      variables: {
                        clientsid:
                          getclient?.aatmsv4_users[0]?.client?.clientsid,
                        fleetsid: dropdown3[0],
                        simlocation: simlocation,
                        simreg: simregistration,
                        validity: datte,
                        simtype: simtype,
                        approval: url,
                      },
                    });
                    emptyState();
                    closeForm();
                  }}
                >
                  Add
                </button>
                <button onClick={() => closeForm()} className="cancel-button">
                  Cancel
                </button>
              </div>
            ) : null}
          </div>
          <div className="qualificationPage__right">
            {url ? (
              <Iframe
                url={url}
                id="pdfId"
                className="pdfClassname"
                display="initial"
                position="relative"
              />
            ) : null}
          </div>
        </div>
      </div>

      {/* Edit */}
      <div className={Edit_sim_form ? "" : "hide-element"}>
        <div className="qualificationPage">
          <div className="addQualification__form qualificationPage__left">
            <div className="addQualification__form--title">
              <span className="client-back" onClick={() => closeForm()}>
                {<LeftOutlined />} Simulators
              </span>
              Edit Simulators
            </div>
            <Text
              title="Client"
              disabled={true}
              value={getclient?.aatmsv4_users[0]?.client?.clientname}
            />
            <Text
              title="Fleet"
              disabled={true}
              value={currentFormData?.fleet?.aircraft}
            />
            <Text
              title="Sim-Registration"
              disabled={true}
              value={currentFormData?.simreg}
              onChange={(e) => setSimregistration(e.target.value)}
            />
            <Text
              title="Sim-Type"
              disabled={true}
              value={currentFormData?.simtype}
              onChange={(e) => setSimtype(e.target.value)}
            />
            <Text
              title="Sim-Location"
              disabled={true}
              value={currentFormData?.simlocation}
              onChange={(e) => setSimlocation(e.target.value)}
            />
            <Calender
              placeholder={currentFormData.validity}
              title="Approval Validity"
              onChange={setDate}
            />
            <p>Active</p>
            <Select
              defaultValue={"Select Active"}
              onChange={(e) => handleFormFields(e, "active")}
            >
              <Option value={true}>Yes</Option>
              <Option value={false}>No</Option>
            </Select>
            <div>
              <input
                type="file"
                style={{ backgroundColor: "beige", borderRadius: "25px" }}
                onChange={handChange}
              />
              <br />
              {/* <a href={currentFormData.approval} target="_blank">
                View Document
              </a> */}
              <br />
              {!url ? (
                <button className="cancel-button" onClick={handleUpdate}>
                  Save
                </button>
              ) : null}
            </div>
            {url !== "" ? (
              <div>
                <button
                  className="submit-button"
                  onClick={() => {
                    updatesims({
                      variables: {
                        validity: date !== "" ? date : currentFormData?.date,
                        approval: url,
                        active: currentFormData.active,
                        sid: currentFormData?.sid,
                      },
                    });
                    emptyState();
                    closeForm();
                  }}
                >
                  Add
                </button>
                <button onClick={() => closeForm()} className="cancel-button">
                  Cancel
                </button>
              </div>
            ) : null}
          </div>
          <div className="qualificationPage__right">
            {currentFormData.approval ? (
              <Iframe
                url={currentFormData.approval}
                id="pdfId"
                className="pdfClassname"
                display="initial"
                position="relative"
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Simulators;
